var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-chip",
    {
      staticClass: "d-inline-flex align-center",
      attrs: {
        color: _vm.almostEnded || _vm.isExpired ? "red" : "accent",
        "text-color": "white",
        role: "status",
        "aria-live": "polite",
        "aria-label": _vm.time,
      },
    },
    [
      _c("v-icon", { attrs: { left: "", "aria-hidden": "true" } }, [
        _vm._v("\n    fad fa-stopwatch\n  "),
      ]),
      _vm._v(" "),
      _c("span", { attrs: { "aria-hidden": "true" } }, [
        _vm._v(_vm._s(_vm.time)),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "sr-only" }, [_vm._v(_vm._s(_vm.time))]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }